import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import ConfirmDialogViewModel from "viewModels/confirmDialogViewModel";

const confirmDialogView: ViewComponent<ConfirmDialogViewModel> = observer(({ vm }) => {
  return (
    <Modal
      centered={true}
      show={vm.isOpened}
      onHide={vm.cancel}
      onEscapeKeyDown={vm.cancel}
      dialogClassName="confirm-dialog"
      backdropClassName="confirm-dialog-backdrop">
      <Modal.Body className="justify-content-center text-center">
        {vm.title && (
          <Modal.Title as="h3" className="mb-3">
            {vm.title}
          </Modal.Title>
        )}
        {vm.message}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button size="sm" onClick={vm.cancel} variant={vm.cancelButtonParams.variant}>
          {vm.cancelButtonParams.text}
        </Button>
        <Button size="sm" onClick={vm.confirm} variant={vm.confirmButtonParams.variant}>
          {vm.confirmButtonParams.text}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default registerView(confirmDialogView, ConfirmDialogViewModel);
